import { AHText } from "arkh";
import React, { ReactNode } from "react";

export function NumberText(props: { children?: ReactNode }) {
  return (
    <AHText style={{}} numberOfLines={1} type="title">
      {props.children}
    </AHText>
  );
}
